export const FETCH_BROCHURE = 'BROCHURE_EDITOR/FETCH_BROCHURE';
export const FETCH_BROCHURE_SUCCESS = 'BROCHURE_EDITOR/FETCH_BROCHURE_SUCCESS';
export const FETCH_BROCHURE_ERROR = 'BROCHURE_EDITOR/FETCH_BROCHURE_ERROR';
export const FETCH_DEPARTMENT = 'BROCHURE_EDITOR/FETCH_DEPARTMENT';
export const FETCH_DEPARTMENT_SUCCESS = 'BROCHURE_EDITOR/FETCH_DEPARTMENT_SUCCESS';
export const FETCH_DEPARTMENT_ERROR = 'BROCHURE_EDITOR/FETCH_DEPARTMENT_ERROR';
export const ADD_TO_CART = 'BROCHURE_EDITOR/ADD_TO_CART';
export const ADD_TO_CART_SUCCESS = 'BROCHURE_EDITOR/ADD_TO_CART_SUCCESS';
export const ADD_TO_CART_ERROR = 'BROCHURE_EDITOR/ADD_TO_CART_ERROR';
export const ADD_FAVORITE = 'BROCHURE_EDITOR/ADD_FAVORITE';
export const ADD_FAVORITE_SUCCESS = 'BROCHURE_EDITOR/ADD_FAVORITE_SUCCESS';
export const ADD_FAVORITE_ERROR = 'BROCHURE_EDITOR/ADD_FAVORITE_ERROR';
export const CHECK_FAVORITE = 'BROCHURE_EDITOR/CHECK_FAVORITE';
export const CHECK_FAVORITE_SUCCESS = 'BROCHURE_EDITOR/CHECK_FAVORITE_SUCCESS';
export const CHECK_FAVORITE_ERROR = 'BROCHURE_EDITOR/CHECK_FAVORITE_ERROR';
export const SET_TEMPLATE_CODE = 'BROCHURE_EDITOR/SET_TEMPLATE_CODE';
export const SET_QUANTITY = 'BROCHURE_EDITOR/SET_QUANTITY';
export const SET_NOTES = 'BROCHURE_EDITOR/SET_NOTES';
export const SET_TYPE = 'BROCHURE_EDITOR/SET_TYPE';
export const SET_CLINIC_NAME = 'BROCHURE_EDITOR/SET_CLINIC_NAME';
export const SET_ADDRESS = 'BROCHURE_EDITOR/SET_ADDRESS';
export const SET_CITY = 'BROCHURE_EDITOR/SET_CITY';
export const SET_ZIP = 'BROCHURE_EDITOR/SET_ZIP';
export const SET_MAIN = 'BROCHURE_EDITOR/SET_MAIN';
export const SET_FAX = 'BROCHURE_EDITOR/SET_FAX';
export const RESET_STATE = 'BROCHURE_EDITOR/RESET_STATE';
export const SET_ACTION = 'BROCHURE_EDITOR/SET_ACTION';